(function(){
    angular
        .module('appback')
        .directive('ngBiologiamolecular', biologiamolecular);

        biologiamolecular.$inject = ['$timeout','GenerallabService','ResultadosService'];
        function biologiamolecular($timeout,GenerallabService,ResultadosService){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=biologiamolecular.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  //sub: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {


		            	scope.potencia = function(base,exponente){
							var r = 1;
							var i = 0; 
							while(i < exponente){
							    r = r * base;
							    i++;
							}
							return r;
		            	}
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : {  }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { };
					            	}
					            }
				            }
				        }
				        console.log("biologia");
				        scope.ct = {};
				        ResultadosService.getCtAnalitica(scope.item.analitica_id,function(data){
				        	scope.ct = data.ct;
				        });

				     	scope.generalLab = GenerallabService;

			        });
		        }
          }
      }
})();